import React from "react";
import { Snackbar, Alert, Slide } from "@mui/material";

// Function to control slide transition direction
function SlideTransition(props) {
  return <Slide {...props} direction="down" />;
}

const SnackbarMessage = ({ message, setMessage }) => {
  const handleClose = () => {
    setMessage(""); // Clear the message when Snackbar is closed
  };

  return (
    <Snackbar
      open={Boolean(message)}
      autoHideDuration={2000} // Snackbar disappears after 4 seconds
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }} // Position at the top
      TransitionComponent={SlideTransition} // Slide transition
    >
      <Alert onClose={handleClose} severity="success" variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarMessage;
